export default class SignaturePositionsResponse {
  pageId!: string
  elementId!: string
  signed!: boolean
  userId!: string
  signatureId!: string
}
